import { GET_OUTLET_FILTERS, GET_OUTLET_FILTERS_SUCCESS, GET_OUTLET_FILTERS_ERROR, GET_OUTLET_FILTERS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetOutletFilters = (state = initialState, action) => {
  switch (action.type) {
    case GET_OUTLET_FILTERS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_OUTLET_FILTERS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_OUTLET_FILTERS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_OUTLET_FILTERS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetOutletFilters;
